import { useTranslations } from 'next-intl';
import { useCallback } from 'react';

export function useFormatGateGroup(): (gateGroup: { id: string; name?: string | null }) => string {
  const t = useTranslations('dictionaries.gate');

  return useCallback(
    (currency) => {
      return currency.id === '' ? t('all') : currency.name || currency.id;
    },
    [t]
  );
}
